import { SubjectLine, Template } from 'sections/onsite-campaigns/types';
import { DomainRule } from '../../types';

export interface SendEmailRequiredConfigRuleDto {
  template: Template;
  subjectLine: SubjectLine;
}

export const SendEmailRequiredConfigRuleKey = 'sendEmailRequiredConfig';

export const SendEmailRequiredConfigRule = (settings: SendEmailRequiredConfigRuleDto): DomainRule => {
  if (!settings?.template?.id || !settings?.subjectLine?.id) {
    return {
      result: 'fail',
      ruleKey: SendEmailRequiredConfigRuleKey,
    };
  }

  return {
    result: 'pass',
    ruleKey: null,
  };
};
